// Third-party
import React from 'react';
import Dotdotdot from 'react-dotdotdot';

// Constant and types
import ComparisonItemType from '@/types/comparison-item-type';

export type ContentPanelDragPreviewItem = {
  key: string;
  label: string;
  type: ComparisonItemType;
  disabled: boolean;
  selected: boolean;
};

type Props = {
  item: ContentPanelDragPreviewItem;
};

const ContentPanelDragPreview = (props: Props) => (
  <div className="proposal-item-drag-preview">
    <Dotdotdot useNativeClamp clamp={2}>
      {props.item.label}
    </Dotdotdot>
  </div>
);

export default ContentPanelDragPreview;
